import { DialogService } from '@enauka/shared/ui/dialogs';
import { LocalStorageService } from '@enauka/shared/ui';
import { Injectable, ErrorHandler, Injector, ApplicationRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Errors } from './errors';
import { WyjatekWPrzegladarceCSService } from '@enauka/shared/infrastructure/clickstream';

const SKIPPED = [401, 503, 504];

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private injector: Injector,
    private localStorageService: LocalStorageService
  ) { }

  handleError(error: Error | HttpErrorResponse) {
    const appRef = this.injector.get(ApplicationRef);

    const dialogService = this.injector.get(DialogService);
    const wyjatekWPrzegladarceCSService = this.injector.get(WyjatekWPrzegladarceCSService);

    if (error instanceof HttpErrorResponse) {
      if (!SKIPPED.includes(error.status)) {
        switch (error.status) {
          case 0:
            dialogService.alert('Problem z realizacją żądzania', "Prawdopodobnie występują problemy z internetem.");
            break;

          default:
            dialogService.alert('Błąd', Errors.getMessage(error));
            break;
        }
      }
    } else {
      // Client Error
    }

    wyjatekWPrzegladarceCSService.rejestrujWyjatek(error, this.getContextMessage());
    console.error(error);
  }

  private getContextMessage() {
    if (this.localStorageService) {
      const aktualneZadanie = this.localStorageService.getItem('kontener-zadan.aktualneZadanie.id');
      const aktualneZadanieNieZrobione = this.localStorageService.getItem('kontener-zadan.aktualnieNieZrobioneZadanie.id');
      if (aktualneZadanie || aktualneZadanieNieZrobione) {
        return `[kontener zdan: zaktualneZadanie.id: ${aktualneZadanie}, aktualnieNieZrobioneZadanie.id: ${aktualneZadanieNieZrobione}`;
      }
    }
    return
  }


}
